import { tasks } from './../../../mock-api/apps/tasks/data';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DetalleSolicitudVADTO } from 'app/models/solicitud-va-dto';
import {MatExpansionModule} from '@angular/material/expansion'; 
import { MatIconModule } from '@angular/material/icon';
import { UtilsService } from 'app/modules/utils-service';
import { DetalleTareaService } from 'app/modules/admin/detalle-tareas/detalle-tareas-service';
import { Tarea } from 'app/models/tareas.model';
import { customDialogResponse, DialogDataInterface } from 'app/modules/GlobalComponents/confirm-dialog-with-notes/dialog-data.interface';
import { ActualizarMetadataDTO } from 'app/models/actualizar-metadata.model';
import { environment as env } from 'environments/environments';
import { ComentariosService } from '../cometarios/comentarios.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'detalle-solicitud-va',
    templateUrl: 'detalle-solicitud-va.html',
    imports: [CommonModule, MatButtonModule, MatExpansionModule, MatIconModule, MatButtonModule  ]
})

export class DetalleSolicitudVaComponent {
    @Input() solicitud: Tarea
    tareaUuid:string
    url_base:string
    solicitudActualizada: Tarea
    estadoRechazado:number= 1
    estadoAceptado:number= 2
    tareaTipoSolicitud:number = env.TIPOLOGIA_ID_SOLICITUDES

    constructor(
      private utilsService: UtilsService, 
      private detalleTareaService:DetalleTareaService,
      private cd: ChangeDetectorRef,
      private _comentariosService:ComentariosService
    ) {
        this.tareaUuid = this.utilsService.activeEntityUuid
        this.url_base= env.URL_BASE_PARA_IMAGENES
      }

    // Accesor para obtener los bloques principales del Acordion
    get bloquesGenerales(): string[] {
        // obtenemos los bloques generales de la solicitud
        return Object.keys(this.solicitud.metadata.Formulario)
          .filter(key => this.solicitud.metadata.Formulario[key] !== null)
          .map(key => key);
    }

    // Iteramos los bloques principales para obtener sub bloques o los campos que contienen valor.
    getBloquesPlanoYSubbloques(obj: any): { label: string, campos: { clave: string, valor: any }[] }[] {
        if (!obj || typeof obj !== 'object') return [];
      
        const resultado: { label: string, campos: { clave: string, valor: any }[] }[] = [];
      
        for (const key of Object.keys(obj)) {
          const value = obj[key];
      
          if (value === null || value === undefined) continue;
      
          // Si es primitivo, lo agrupamos en un bloque "Principal"
          if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            let principal = resultado.find(r => r.label === 'General');
            if (!principal) {
              principal = { label: 'General', campos: [] };
              resultado.push(principal);
            }
            principal.campos.push({ clave: key, valor: value });
          }
      
          // Si es un objeto (sub-bloque), lo agregamos como bloque independiente
          else if (typeof value === 'object' && !Array.isArray(value)) {
            const subcampos = this.getCamposPlano(value);
            resultado.push({ label: key, campos: subcampos });
          }
      
          // Si es array, recorremos sus objetos
          else if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (typeof item === 'object') {
                resultado.push({
                  label: `${key} [${index + 1}]`,
                  campos: this.getCamposPlano(item)
                });
              }
            });
          }
        }
      
        return resultado;
      }
      

      // metodo para obtner la llave valor del json a mostrar
      getCamposPlano(obj: any): { clave: string, valor: any }[] {
        if (!obj || typeof obj !== 'object') return [];
      
        const campos: { clave: string, valor: any }[] = [];
      
        for (const key of Object.keys(obj)) {
          const value = obj[key];
          const fullKey = key;
      
          if (value === null || value === undefined) continue;
      
          if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            campos.push({ clave: fullKey, valor: value });
          } else if (typeof value === 'object' && !Array.isArray(value)) {
            campos.push(...this.getCamposPlano(value));
          }
        }
      
        return campos;
      }
      


      //** metodo auxiliar para excluir propiedades de la vista */
      exludelabel(label: string){
        
        // se usan minusculas para mejor comparacion
        const skipeLabel = [
            'pasos',
            'tipopersona',
            'tiposolicitante',
            'institucioneducativa',
            'tipodocumento',
            'nacionalidad',
            'extension',
            'ruta',
            'epoca',
            'municipio',
            'departamento',

        ]

        // al comparar se usan minusculas
        return skipeLabel.includes(label.toLocaleLowerCase())

      }
      
    async rechazarBloqueInformacion(nombreFormulario: string) {
      const estadoFormulario = this.estadoRechazado;
      // Crear una copia mutable del objeto solicitud
      const pasosCopia = { ...this.solicitud.metadata.Formulario[nombreFormulario].Pasos };
    
        const dialogConfig: DialogDataInterface = {
            title: `Confirmación para Rechazar ${nombreFormulario}`,
            description: `Está seguro que desea Rechazar ${nombreFormulario}, agregue un comentario para confirmar la acción.`,
            dimissible: false
        };
    
        const dialogResponse: customDialogResponse = await this.utilsService.openConfirDialogWithNotes(dialogConfig);
    
        if (!dialogResponse) {
            console.error("El diálogo no retornó una respuesta válida.");
            return;
        }
    
        if (dialogResponse.confirmed) {
            if (this.solicitud.metadata?.Formulario?.hasOwnProperty(nombreFormulario)) {
                const formulario = this.solicitud.metadata.Formulario[nombreFormulario];

                // Modificamos los valores de pasos
                pasosCopia.Estado = estadoFormulario;
                pasosCopia.Comentario = dialogResponse.comentarios;

                // Inicializar datosActualizarMetadata solo si se confirma la acción
                const datosActualizarMetadata: ActualizarMetadataDTO = {
                  tarea: {
                    ...this.solicitud,
                    metadata: {
                      ...this.solicitud.metadata,
                      Formulario: {
                        ...this.solicitud.metadata.Formulario,
                        [nombreFormulario]: {
                          ...this.solicitud.metadata.Formulario[nombreFormulario],
                          Pasos: pasosCopia // Solo modificamos Pasos aquí
                        }
                      }
                    }
                  },
                  accion: {
                    comentario: dialogResponse.comentarios,
                    estado: estadoFormulario,
                    bloque: nombreFormulario,
                    paso: formulario.Pasos.Numero
                  }
                };
    
                try {
                    await this.detalleTareaService.putMetadata(datosActualizarMetadata, this.tareaUuid);
                    await  this._comentariosService.getComentariosByEntity(this.tareaUuid)
                    await this.detalleTareaService.getTaskDetails(this.tareaUuid)

                } catch (error) {
                    
                }
            }
        }
    }

    async aceptarBloqueInformacion(nombreFormulario: string) {
      const estadoFormulario = this.estadoAceptado;
    
      const pasosCopia = { ...this.solicitud.metadata.Formulario[nombreFormulario].Pasos };

      try {
        // Se usó firstValueFrom para convertir el observable en promesa y poder usar async/await.
        const response = await firstValueFrom(
          this.utilsService.open_confirm_dialog(
            `Está seguro que desea Aceptar ${nombreFormulario}`, 
            `Confirmación para Aceptar ${nombreFormulario}`
          )
        );
    
        if (response === 'confirmed') {
          if (this.solicitud.metadata?.Formulario?.hasOwnProperty(nombreFormulario)) {
            const formulario = this.solicitud.metadata.Formulario[nombreFormulario];
            
            // Modificamos los valores de pasos
            pasosCopia.Estado = estadoFormulario;
            pasosCopia.Comentario = '';
    
            // Construimos los datos para actualizar la metadata
            const datosActualizarMetadata: ActualizarMetadataDTO = {
              tarea: {
                ...this.solicitud,
                metadata: {
                  ...this.solicitud.metadata,
                  Formulario: {
                    ...this.solicitud.metadata.Formulario,
                    [nombreFormulario]: {
                      ...this.solicitud.metadata.Formulario[nombreFormulario],
                      Pasos: pasosCopia // Solo modificamos Pasos aquí
                    }
                  }
                }
              },
              accion: {
                comentario: '',
                estado: estadoFormulario,
                bloque: nombreFormulario,
                paso: formulario.Pasos.Numero
              }
            };
            await this.detalleTareaService.putMetadata(datosActualizarMetadata, this.tareaUuid);
            await this._comentariosService.getComentariosByEntity(this.tareaUuid);
            await this.detalleTareaService.getTaskDetails(this.tareaUuid)
          
          }
        }
      } catch (error) {
        //console.error('Error al aceptar bloque de información', error);
      }
    }

}